import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import ReactGA from 'react-ga';

export const AnalyticsRoot = () => {
  const { pathname, search } = useLocation();

  useEffect(() => {
    if (!process.env.REACT_APP_GA_KEY) return;

    ReactGA.pageview(window.location.pathname + search);
  }, [pathname, search]);

  return <></>;
};
